"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ScreenShare = require("./ScreenShare");
Object.keys(_ScreenShare).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ScreenShare[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ScreenShare[key];
    }
  });
});